import axios from "axios";

// Main/backup webapi hosts. The user picks one in Settings > App Settings;
// the choice is persisted so both axios instances resolve to it (see
// getBASE_URL below), and a failed request to the selected server prompts a
// switch (see NETWORK_ERROR_EVENT / attachNetworkErrorNotifier).
export const SERVERS = {
  main: { label: "Main Server", host: process.env.REACT_APP_SRV },
  backup: { label: "Backup Server", host: process.env.REACT_APP_SRV_BACKUP || "app1.altrack.co.za" },
};

const SERVER_KEY_STORAGE = "altrack_server_key";
export const NETWORK_ERROR_EVENT = "altrack:server-unreachable";

export const getActiveServerKey = function ()
{
  return localStorage.getItem(SERVER_KEY_STORAGE) === "backup" ? "backup" : "main";
};

var getBASE_URL = function (serverKeyOverride)
{
  const host = SERVERS[serverKeyOverride || getActiveServerKey()].host;
  if (process.env.NODE_ENV === 'production') {
    if (process.env.REACT_APP_API_MODE != "STAGE") {
      return "https://" + host + "/webapi";
    } else {
      return "https://" + host + "/webapi/tdebug";
    }
  } else {
    if (process.env.REACT_APP_API_MODE == "STAGE") {
      return "/devproxy";
    } else {
      return "https://localhost:44319";
    }
  }
};

// "https://localhost:44319"; //TODO: check live
//const BASE_URL = "https://localhost:44319";

const axiosInstance = axios.create({
  baseURL: getBASE_URL(),
});

export const axiosPrivate = axios.create({
  baseURL: getBASE_URL(),
  headers: { "Content-Type": "application/json" },
  withCredentials: true
});

// Persists the chosen server and repoints both axios instances at it
// immediately, so the next request (retry included) uses the new host.
export const setActiveServer = function (serverKey)
{
  if (!SERVERS[serverKey]) return getActiveServerKey();
  localStorage.setItem(SERVER_KEY_STORAGE, serverKey);
  const newBaseUrl = getBASE_URL(serverKey);
  axiosInstance.defaults.baseURL = newBaseUrl;
  axiosPrivate.defaults.baseURL = newBaseUrl;
  return serverKey;
};

// A response with no `error.response` means the request never got a reply
// (DNS/connection-refused/timeout/CORS) — i.e. the server itself is
// unreachable, as opposed to it replying with a 4xx/5xx. Broadcast that so
// App.js can offer switching to the other server.
function attachNetworkErrorNotifier(instance)
{
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (!error.response && error.code !== "ERR_CANCELED") {
        window.dispatchEvent(new CustomEvent(NETWORK_ERROR_EVENT, {
          detail: { serverKey: getActiveServerKey() },
        }));
      }
      return Promise.reject(error);
    }
  );
}
attachNetworkErrorNotifier(axiosInstance);
attachNetworkErrorNotifier(axiosPrivate);

export default axiosInstance;
